<div>
  <a (click)="open()">
    @if (content) {
      <p>{{content}}</p>
    }
    @if (!o && hasChilds()) {
      <i class="fas fa-angle-down"></i>
    }
    @if (o && hasChilds()) {
      <i class="fas fa-angle-up"></i>
    }
  </a>
  <i class="{{preicon}}"></i>
  <div #child [style.visibility]="o ? 'visible' : 'hidden'" [style.position]="o ? 'relative' : 'absolute'">
    <ng-content ></ng-content>
  </div>
</div>